import React from 'react';
import { Field, FieldArray, reduxForm } from 'redux-form';
import { LinkContainer } from 'react-router-bootstrap';
import { withRouter, browserHistory } from 'react-router';
import {SortableContainer, SortableElement, arrayMove} from 'react-sortable-hoc';
import MdDragHandle from 'react-icons/lib/md/drag-handle';

const renderField = ({ input, label, type, meta: { touched, error } }) => (
  <div>
    <label>{label}</label>
    <div>
      <input {...input} type={type} placeholder={label} />
      {touched && error && <span>{error}</span>}
    </div>
  </div>
);

const SortableItem = SortableElement(({member, index, fields}) =>
  <div style={{ display: 'flex', flexDirection: 'row', cursor: 'pointer', alignItems: 'center' }}>
    <MdDragHandle color={'rgba(0,0,0,0.1)'} size={24} style={{marginRight: 12}}/>
    <Field name={`${member}.value`} style={{ width: 720, fontSize: 12 }} type="text" component="textarea" placeholder="description" />

  </div>
);

const SortableList = SortableContainer(({items}) => {
  return (
    <div>
      {items.map((member, index) => (
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: 12}} key={`item-${index}`}>
          <SortableItem index={index} member={member} fields={items} />
          <div style={{ fontSize: 12, marginLeft: 16, cursor: 'pointer', color: 'red' }} onClick={() => items.remove(index)}>
            delete
          </div>
        </div>
      ))}
    </div>
  );
});

const renderMembers = ({ fields, meta: { touched, error } }) => {
  const onSortEnd = ({oldIndex, newIndex}) => {
    fields.swap(oldIndex, newIndex);
    arrayMove(fields, oldIndex, newIndex);

  };
  return (
    <div style={{display: 'flex', flexDirection: 'column'}}>
      <SortableList items={fields} onSortEnd={onSortEnd}/>
      <div>
        <div style={{ fontSize: 12, fontWeight: 'bold', cursor: 'pointer', color: 'rgba(51, 163, 243, 1)' }} onClick={() => fields.push({})}>
          + add item
        </div>
        {touched && error && <span>{error}</span>}
      </div>
    </div>
  )
};

const TipsForm = (props) => {
  const { handleSubmit, pristine, reset, submitting } = props;
  return (
    <form onSubmit={handleSubmit} style={{ paddingTop: 48 }}>
      <div style={{ marginBottom: 48 }}>
        <div style={{ marginBottom: 12, fontWeight: 'bold' }}>Insights</div>
        <FieldArray name="insights" component={renderMembers} />
      </div>
      <div style={{ marginBottom: 48 }}>
        <div style={{ marginBottom: 12, fontWeight: 'bold' }}>Strengths</div>
        <FieldArray name="strengths" component={renderMembers} />
      </div>
      <div style={{ marginBottom: 48 }}>
        <div style={{ marginBottom: 12, fontWeight: 'bold' }}>Weaknesses</div>
        <FieldArray name="weaknesses" component={renderMembers} />
      </div>
      <div>
        <button
          type="submit"
          disabled={submitting}
          style={{
            marginRight: 8,
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 12,
            paddingRight: 12,
            backgroundColor: 'rgba(38, 194, 129, 1)',
            borderRadius: 4,
            color: 'white',
            fontSize: 14,
          }}
        >
          Save
        </button>
        <button
          onClick={() => {
            handleSubmit().then(() => {
              browserHistory.push('/championtips');
            });

          }}
          disabled={submitting}
          style={{
            marginRight: 8,
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 12,
            paddingRight: 12,
            backgroundColor: 'rgba(38, 194, 129, 1)',
            borderRadius: 4,
            color: 'white',
            fontSize: 14,
          }}
        >
          Save and go back
        </button>
        {/* <button
          onClick={() => {
            browserHistory.push('/championtips');
          }}
          style={{
            marginRight: 8,
            paddingTop: 6,
            paddingBottom: 6,
            paddingLeft: 12,
            paddingRight: 12,
            backgroundColor: 'rgba(243, 83, 83, 1)',
            borderRadius: 4,
            color: 'white',
            fontSize: 14,
          }}
        >
          Cancel
        </button> */}
      </div>
    </form>
  );
};

export default reduxForm({
  form: 'tips',
  enableReinitialize: true,
  destroyOnUnmount: false,
})(TipsForm);



// WEBPACK FOOTER //
// ./src/cms/tips/ChampionTipsForm.js